import {
  breakpoint,
  ClockIcon,
  GavelIcon,
  ActionTimeSection,
  ActionTimeInput,
} from '@grays-npm/component-library';
import { format, formatDistanceToNow } from '../../mock-data/utils';
import styled, { css } from 'styled-components';

type ListingTimeEntryType =
  | 'bid'
  | 'offer'
  | 'pending'
  | 'auction'
  | 'sold'
  | 'unsold';

function formatDateInput(value: ActionTimeInput) {
  const date = typeof value === 'string' ? new Date(value) : value;
  return date;
}

function setTimeFormatter(value: ActionTimeInput) {
  const date = formatDateInput(value);
  return format('HH:mm, dd/MM/yy')(date);
}
function relativeFormatter(value: ActionTimeInput) {
  const date = formatDateInput(value);
  return formatDistanceToNow(date);
}

const DefaultIconStyles = css`
  fill: ${({ theme }) => theme.colors.neutrals.solidGrays[1]};
  width: 12px;
  height: 12px;

  ${breakpoint('sm')`
    width: 14px;
    height: 14px;
  `}
`;

const StyledGavelIcon = styled(GavelIcon)`
  ${DefaultIconStyles};
`;

const StyledClockIcon = styled(ClockIcon)`
  ${DefaultIconStyles}
`;

const listingItemTimeByType = {
  bid: {
    icon: StyledClockIcon,
    content: <strong>Bid expires in</strong>,
    formatter: relativeFormatter,
  },
  offer: {
    icon: StyledClockIcon,
    content: <strong>Offer expires in</strong>,
    formatter: relativeFormatter,
  },
  auction: {
    icon: StyledClockIcon,
    content: <strong>Closes in</strong>,
    formatter: relativeFormatter,
  },
  pending: {
    icon: StyledClockIcon,
    content: 'Expected start:',
    formatter: setTimeFormatter,
  },
  sold: {
    icon: StyledClockIcon,
    content: <strong>Ended at</strong>,
    formatter: setTimeFormatter,
  },
  unsold: {
    icon: StyledClockIcon,
    content: <strong>Ended at</strong>,
    formatter: setTimeFormatter,
  },
};

export type ListingTimeSectionProps = {
  time: ActionTimeInput;
  type: ListingTimeEntryType;
  duration?: string;
};

export const ListingTimeSection: React.FC<ListingTimeSectionProps> = ({
  time,
  type,
  duration,
}) => {
  const listingItemTimeField = listingItemTimeByType[type];
  const durationText = (
    <>
      Auction duration: <strong>{duration}</strong>
    </>
  );
  return (
    <ActionTimeSection
      time={time}
      actionItemTimeField={listingItemTimeField}
      durationText={duration ? durationText : undefined}
      durationIcon={StyledGavelIcon}
    />
  );
};
